/** Figma `37:901` + `37:792` — Signal Provider List filter tokens. */

export const SP_LIST_FILTERS_BUTTON_WIDTH_PX = 192
export const SP_LIST_FILTER_TRIGGER_HEIGHT_PX = 42
export const SP_LIST_FILTER_TRIGGER_BORDER = '#e1e7f3'
export const SP_LIST_FILTER_TRIGGER_LABEL_COLOR = '#64748b'

export const SP_LIST_DEMOGRAPHIC_PANEL_BORDER = '#e0e5eb'
export const SP_LIST_DEMOGRAPHIC_PANEL_BG = '#ffffff'
export const SP_LIST_DEMOGRAPHIC_PANEL_SHADOW = '0px 8px 20px rgba(0, 0, 0, 0.2)'
export const SP_LIST_DEMOGRAPHIC_PANEL_PADDING_X_PX = 19.5
export const SP_LIST_DEMOGRAPHIC_PANEL_PADDING_TOP_PX = 20
export const SP_LIST_DEMOGRAPHIC_PANEL_HEADER_BOTTOM_PX = 12
export const SP_LIST_DEMOGRAPHIC_FILTER_COL_WIDTH_PX = 184.5
export const SP_LIST_DEMOGRAPHIC_FILTER_ROW_GAP_PX = 12
export const SP_LIST_DEMOGRAPHIC_FILTER_LABEL_GAP_PX = 6
export const SP_LIST_DEMOGRAPHIC_DROPDOWN_HEIGHT_PX = 36
export const SP_LIST_DEMOGRAPHIC_DROPDOWN_BORDER = '#e4e9f0'
export const SP_LIST_DEMOGRAPHIC_LABEL_COLOR = '#6b7a90'
export const SP_LIST_DEMOGRAPHIC_VALUE_COLOR = '#0f172a'

export const spListHeaderFilterTriggerSx = {
  height: SP_LIST_FILTER_TRIGGER_HEIGHT_PX,
  flexShrink: 0,
  borderRadius: '10px',
  border: '1px solid',
  borderColor: SP_LIST_FILTER_TRIGGER_BORDER,
  bgcolor: '#ffffff',
  px: '16px',
  py: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
  textAlign: 'left',
  '&:hover': { bgcolor: '#ffffff' },
  '&.Mui-focusVisible': {
    borderColor: '#008cd0',
    outline: 'none',
  },
} as const

export const spListHeaderFilterTriggerLabelSx = {
  fontSize: 14,
  fontWeight: 600,
  lineHeight: 'normal',
  letterSpacing: '-0.1504px',
  color: SP_LIST_FILTER_TRIGGER_LABEL_COLOR,
} as const
